
import React from 'react';
import { useDispatch  } from 'react-redux';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { DialogConfirm } from '../../../core';

import useDatawinDataModelItem from '../../hooks/useDatawinDataModelItem';
import useDatawinFetchPanelVisibility from '../../hooks/useDatawinFetchPanelVisibility';
import { getActions } from '../../sagas';

import DataModelItemCombobox from './DataModelItemCombobox';
import ObjectListOperations from './ObjectListOperations';

const DataWindowHeader = ({
    appActions,
    selection
}) => {

    const classNames = mergeStyleSets({
        DataWindowHeader: {
            paddingLeft: 12,
            paddingBottom: 8,
            paddingRight: 8,
            borderBottom: '1px #eeeeee solid'
        },
        dataModelItem: {
            width: 300
        }
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const dataModelItem = useDatawinDataModelItem();
    const fetchPanelVisibility = useDatawinFetchPanelVisibility();

    const handleClear = async () => {
        const confirm = await DialogConfirm.show("Opravdu chcete odstranit všechny objektu z aktuálního seznamu?");
        if (confirm) {
            dataActions.setDatawinObjectList(dataModelItem.id, [], 'SET');
        }
    }

    const handleFetch = () => {
        dataActions.setDatawinFetchPanelVisibility(true);
    }

    const handleToMapClick = () => {
        appActions.setUiValue('activeWindow', 'map');
    }

    return (
        <Stack horizontal verticalAlign="center" className={classNames.DataWindowHeader} tokens={{childrenGap: 8}}>
            <div>Typ objektů: </div>
            <Stack.Item className={classNames.dataModelItem}>
                <DataModelItemCombobox />
            </Stack.Item>
            <Stack.Item grow >
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <DefaultButton
                        disabled={!dataModelItem || fetchPanelVisibility}
                        iconProps={{iconName: 'DatabaseSync'}}
                        onClick={handleFetch}
                        title="Zobrazit panel pro načtení objektů"
                    />
                    <ObjectListOperations
                        dataModelItem={dataModelItem}
                        selection={selection}
                    />
                    <DefaultButton
                        disabled={!dataModelItem || !selection || (selection.workObjectList.length === 0)}
                        onClick={handleClear}
                        text="Vyčistit seznam"
                        title="Odstranit všechny objektu z aktuálního seznamu"
                    />
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <DefaultButton onClick={handleToMapClick}>Zpět do mapového okna</DefaultButton>
            </Stack.Item>
        </Stack>
    );
}

export default DataWindowHeader;
